'use client';

import { SpeedInsights } from '@vercel/speed-insights/next';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import { PostHogProvider } from '@/lib/posthog';

export function RootTelemetry({
  children,
  afterProvider,
}: {
  children: ReactNode;
  afterProvider: ReactNode;
}) {
  const pathname = usePathname();
  // Decide before mounting providers; URL scrubbing in a child effect is too late.
  if (pathname === '/checkout/complete')
    return (
      <>
        {children}
        {afterProvider}
      </>
    );
  return (
    <>
      <PostHogProvider>{children}</PostHogProvider>
      {afterProvider}
      <SpeedInsights />
    </>
  );
}
